// utils/delete-cookie.ts
export const deleteCookie = (name: string) => {
    document.cookie = `${name}=; path=/; max-age=0; SameSite=None; Secure`;
};
